import React from "react";
import { Select } from "semantic-ui-react";
import { useGraphDispatch } from "../StateManagement";
import type { ChartType } from "../StateManagement/GraphContext";

export const DataPresentationDropdown = () => {
	const { updateChartType } = useGraphDispatch();

	return (
		<>
			<span style={{ width: 100, fontSize: "1em", lineHeight: 1.2, textAlign: "right" }}>
				Data
				<br />
				Presentation
			</span>
			<Select
				compact
				defaultValue={"box-jitter"}
				options={[
					{ text: "Box-Whisker w/ Jitter", value: "box-jitter" },
					{ text: "Bar Chart", value: "bar" },
					{ text: "Data Table", value: "table" },
					{ text: "Timecourse", value: "line" },
				]}
				onChange={(_, { value }) => {
					updateChartType(value as ChartType);
				}}
			/>
		</>
	);
};
